import "./Tag.css";

const Tag = (props) => {
  return (
    <div className="tag">
      {props.text}
    </div>
  );
};

export default Tag;